import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';

function ShopProductTabs({ t, ActiveStep }) {
  let step1 = ' ';
  let step2 = ' ';
  let step3 = ' ';

  if (ActiveStep === 1) {
    step1 = 'step-item active';
    step2 = 'step-item deactivate';
    step3 = 'step-item deactivate';
  }
  if (ActiveStep === 2) {
    step1 = 'step-item';
    step2 = 'step-item active';
    step3 = 'step-item deactivate';
  }
  if (ActiveStep === 3) {
    step1 = 'step-item';
    step2 = 'step-item';
    step3 = 'step-item active';
  }

  return (
    <div className="m-portlet m-portlet--rounded m-portlet--rounded-force m--margin-top-10 m--margin-bottom-10 checkout-wizard">
      <div className="m-portlet__body">
        <div className="checkout-wizard-stepper">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className={step1}>
                <div className="icon-holder">
                  <div className="icon">
                    <i className="fa fa-shopping-bag" />
                  </div>
                </div>
                {/* <div className="icon"><i className="fas fa-list-ul" /></div> */}
                <div className="description">
                  <h2>1.</h2>
                  <h3>{t('shop.cart.you_order')}</h3>
                  <p>{t('shop.cart.select_items_checkout')}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className={step2}>
                <div className="icon-holder">
                  <div className="icon">
                    <i className="fa fa-map-marker-alt" />
                  </div>
                </div>
                {/* <div className="icon"><i className="fas fa-map-marker-alt" /></div> */}
                <div className="description">
                  <h2>2.</h2>
                  <h3>{t('shop.cart.shipping')}</h3>
                  <p>{t('shop.cart.choose_shipping_details')}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className={step3}>
                <div className="icon-holder">
                  <div className="icon">
                    <i className="fa fa-credit-card" />
                  </div>
                </div>
                {/* <div className="icon"><i className="fas fa-euro-sign" /></div> */}
                <div className="description">
                  <h2>3.</h2>
                  <h3>{t('shop.cart.payment')}</h3>
                  <p>{t('shop.cart.choose_payment_method')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ShopProductTabs.propTypes = {
  t: PropTypes.func.isRequired,
  ActiveStep: PropTypes.number.isRequired,
};

export default translate(ShopProductTabs);
